<template>
    <div class="class_body">
        <div style="padding: 20px">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>用户管理</el-breadcrumb-item>
                <el-breadcrumb-item>班级管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!--        <div style="display: flex;justify-content: center;align-items: center;padding-top: 40px">
                    <span style="font-size: 18px;font-weight: bold;">班级管理</span>
                </div>-->
        <div style="padding: 20px">
            <el-row :gutter="10">
                <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="4">
                    <div style="display: flex;justify-content: center;align-items: center;">
                        <span style="width: 100px">名称：</span>
                        <el-input></el-input>
                    </div>
                </el-col>
                <el-col :xs="4" :sm="6" :md="8" :lg="9" :xl="4">
                    <div style="display: flex;align-items: center;">
                        <el-button type="primary" style="background-color: skyblue;border: skyblue">搜索</el-button>
                        <el-button type="primary" style="background-color: skyblue;border: skyblue" @click="opendialog">
                            添加
                        </el-button>
                    </div>
                </el-col>
            </el-row>
            <div>
                <el-dialog title="添加" :visible.sync="dialogFormVisible" width="30%" center>
                    <el-form :model="form">
                        <el-form-item label="班级名称" :label-width="formLabelWidth">
                            <el-input v-model="form.classname" autocomplete="off"></el-input>
                        </el-form-item>
                        <!--                        <el-form-item label="班级年级" :label-width="formLabelWidth">
                                                    <el-input v-model="form.classgrade" autocomplete="off"></el-input>
                                                </el-form-item>-->
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submitclass">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
            <div style="padding: 20px 0px">
                <el-table
                        :data="tableData"
                        border
                        style="width: 100%">
                    <el-table-column
                            type="index"
                            align="center"
                            label="序号"
                            width="60">
                    </el-table-column>
                    <el-table-column
                            prop="departmentName"
                            align="center"
                            label="班级名称">
                    </el-table-column>

                </el-table>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "Classmanagement",
        data() {
            return {
                dialogFormVisible: false,
                formLabelWidth: '70px',
                form: {
                    classname: '',
                    classgrade: ''
                },
                tableData: []

            }
        },
        mounted() {
            console.log(this.$route)
            this.getlist()
        },
        methods: {
            getlist() {
                let url = '/depart/list';
                this.$axios.get(url).then((resp) => {
                    console.log(resp.data.result)
                    if (resp.data.success) {
                        this.tableData = resp.data.result
                    }
                })
            },
            deleterow(row) {
                console.log(row)
            },
            check(row) {
                console.log(row)
            },
            opendialog() {
                this.dialogFormVisible = true
               /* this.getParentCateList();*/
            },
            submitclass() {
                let url = '/depart/save';
                let param = {
                    departmentName: this.form.classname
                };
                this.$axios.post(url, param).then((resp) => {
                    console.log(resp)
                    if (resp.data.code === 200) {
                        this.$message.success('操作成功！')
                        this.dialogFormVisible = false;
                        this.getlist()
                    } else {
                        this.$message.error('操作失败！')
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .class_body {

    }

    .el-dialog {
        width: 25%;
    }

    .el-col {
        border-radius: 4px;
    }

    .bg-purple-dark {
        background: #99a9bf;
    }

    .bg-purple {
        background: #d3dce6;
    }

    .bg-purple-light {
        background: #e5e9f2;
    }

    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }
</style>
